export default __webpack_public_path__ + "static/media/39_mobile.1d3ea177.jpg";